import { __generator } from "tslib";
import { put, call, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as actionTypes from '../constants/actionTypes';
import { showScreenInfo, hideScreenInfo } from '../actionCreators';
var actions = [
    actionTypes.SHOW_NEXT,
    actionTypes.SHOW_PREVIOUS,
    actionTypes.SHOW_HOME,
];
export default function showScreenInfoSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(actions, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, put(showScreenInfo())];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, call(delay, 1000)];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, put(hideScreenInfo())];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
